import API from "../API";

export default {
    namespaced: true,

    state() {
        return {
            jsonFilePath: '',
            imageFilePath: '',
            errorPathFileJSON: false,
            errorPathFilePNG: false,
        }
    },

    getters: {
        fileName(state, getters, rootState) {
            return `${rootState['trimInfo'].trimName}`;
        },

        errors(state) {
            return state.errorPathFileJSON || state.errorPathFilePNG;
        },

    },

    mutations: {
        setJSONFilePath(state, filePath) {
            state.jsonFilePath = filePath;
        },

        setImageFilePath(state, filePath) {
            state.imageFilePath = filePath;
        },

        setErrorJSONFilePath(state, error) {
            state.errorPathFileJSON = error;
        },

        setErrorImageFilePath(state, error) {
            state.errorPathFilePNG = error;
        },

    },

    actions: {
        getSaveSettings({dispatch}) {
            return new Promise((resolve, reject) => {
                API.saveSettings.getSaveSettings().then(
                    (response) => {
                        let data = response.data;
                        let errors = response.errors;

                        if (errors) {
                            dispatch('setErrors', errors);
                        }

                        let jsonFilePath = data.jsonFilePath;
                        let imageFilePath = data.imageFilePath;

                        dispatch('doSaveSettings', { jsonFilePath, imageFilePath });

                        resolve();
                    })
                    .catch((error) => {
                        console.log(error);
                        reject(error);
                    });
            });
        },

        saveTheSettings({state, dispatch}/*, { jsonFilePath, imageFilePath }*/) {
            return new Promise((resolve, reject) => {

                dispatch('clearErrors');

                const jsonFilePath = state.jsonFilePath;
                const imageFilePath = state.imageFilePath;

                API.saveSettings.saveTheSettings({ jsonFilePath, imageFilePath }).then(
                    (response) => {
                        let errors = response.errors;

                        if (errors) {
                            dispatch('setErrors', errors);

                            reject();
                            return;
                        }

                        dispatch('doSaveSettings', response.data);

                        resolve();
                    }, (error) => {
                        reject(error);
                    });
            });
        },

        doSaveSettings({commit}, { jsonFilePath, imageFilePath }) {
            commit('setJSONFilePath', jsonFilePath);
            commit('setImageFilePath', imageFilePath);
        },

        setErrors({commit}, errors) {
            commit('setErrorJSONFilePath', errors.json);
            commit('setErrorImageFilePath', errors.image);
        },

        clearErrors({commit}) {
            commit('setErrorJSONFilePath', false);
            commit('setErrorImageFilePath', false);
        },

    }
}